import React, { useMemo } from 'react';
import { CodeEditor } from './CodeEditor';
import { ICodeEditorViewProps } from './types';

export const CodeEditorView = ({
	id,
	values,
	editable,
	currentTheme,
	onChange,
	lang,
	...rest
}: ICodeEditorViewProps) => {
	const views = useMemo(
		() =>
			values.map(({ id: viewId, value }) => ({
				id: viewId,
				view: (
					<CodeEditor
						{...rest}
						id={id}
						value={value}
						onChange={(change) => onChange(viewId, change)}
						editable={editable}
						theme={currentTheme}
						lang={lang}
					/>
				)
			})),
		[id, values, editable, currentTheme, lang, onChange, rest]
	);

	const { view } = views.filter((v) => v.id === id)[0];

	return view;
};

export default CodeEditorView;
